const cards = [
  {
    title: '《暗夜追踪》——年度悬疑黑马',
    desc: '一桩离奇命案牵出惊天阴谋，豆瓣开分8.9，全网热议。蚂蚁影视全网首播，高清画质还原每一个细节线索。',
    img: 'https://readdy.ai/api/search-image?query=A%20dark%20noir%20cinematic%20scene%2C%20rainy%20urban%20alley%20with%20warm%20amber%20street%20lamp%20glow%2C%20mysterious%20atmosphere%2C%20film%20grain%20texture%2C%20dramatic%20shadows%2C%20thriller%20movie%20aesthetic&width=640&height=360&seq=card-01&orientation=landscape',
    tag: '全网首播',
    tagStyle: 'bg-accent-500/15 text-accent-400',
  },
  {
    title: '《长安十二时辰》续集定档',
    desc: '原班人马回归，故事升级，场景更宏大。蚂蚁影视同步跟播，每周五晚8点准时更新，追剧党不可错过。',
    img: 'https://readdy.ai/api/search-image?query=A%20cinematic%20ancient%20Chinese%20city%20scene%20with%20warm%20lantern%20glow%2C%20traditional%20architecture%2C%20golden%20amber%20lighting%2C%20epic%20historical%20drama%20aesthetic%2C%20atmospheric%20night%20scene&width=640&height=360&seq=card-02&orientation=landscape',
    tag: '同步跟播',
    tagStyle: 'bg-primary-500/15 text-primary-400',
  },
  {
    title: '暑期亲子观影指南',
    desc: '精选20部适合全家观看的优质影片，寓教于乐。蚂蚁影视特别整理，让孩子在观影中收获知识与快乐。',
    img: 'https://readdy.ai/api/search-image?query=A%20warm%20family%20movie%20night%20scene%20with%20golden%20cozy%20lighting%2C%20soft%20pillows%20and%20blankets%2C%20cinematic%20atmosphere%2C%20gentle%20amber%20glow%2C%20home%20theater%20aesthetic&width=640&height=360&seq=card-03&orientation=landscape',
    tag: '专题策划',
    tagStyle: 'bg-green-500/15 text-green-400',
  },
  {
    title: '国外最新高分剧集速递',
    desc: 'IMDb 8.5+、烂番茄新鲜度95%以上的口碑神剧，蚂蚁影视精选译制，中英双语字幕助你无障碍追剧。',
    img: 'https://readdy.ai/api/search-image?query=A%20cinematic%20international%20drama%20scene%20with%20warm%20golden%20lighting%2C%20modern%20urban%20setting%2C%20sophisticated%20atmosphere%2C%20film%20reel%20aesthetic%2C%20professional%20photography%20style&width=640&height=360&seq=card-04&orientation=landscape',
    tag: '海外精选',
    tagStyle: 'bg-primary-500/15 text-primary-400',
  },
  {
    title: '经典港片修复计划上线',
    desc: '那个黄金年代的港片记忆，蚂蚁影视4K修复版已上线。周星驰、成龙、王家卫经典作品高清重现。',
    img: 'https://readdy.ai/api/search-image?query=A%20nostalgic%20Hong%20Kong%20cinema%20scene%20with%20warm%20neon%20glow%2C%20retro%20street%20atmosphere%2C%20golden%20amber%20lights%2C%20classic%20film%20aesthetic%2C%20vintage%20cinematic%20vibe&width=640&height=360&seq=card-05&orientation=landscape',
    tag: '4K修复',
    tagStyle: 'bg-accent-500/15 text-accent-400',
  },
  {
    title: '纪录片《地球脉动III》上线',
    desc: 'BBC顶级制作团队历时5年拍摄，蚂蚁影视获授权播出。震撼的4K画面展现地球最壮美的自然奇观。',
    img: 'https://readdy.ai/api/search-image?query=A%20breathtaking%20nature%20documentary%20scene%20with%20warm%20golden%20sunset%20over%20mountains%2C%20cinematic%20landscape%2C%20rich%20amber%20and%20coral%20tones%2C%20epic%20scale%2C%20professional%20wildlife%20photography&width=640&height=360&seq=card-06&orientation=landscape',
    tag: '纪录片',
    tagStyle: 'bg-green-500/15 text-green-400',
  },
  {
    title: '蚂蚁影视原创短片大赛征稿',
    desc: '首届蚂蚁影视青年导演扶持计划启动！面向全国征集原创短片，最高奖金10万元，优秀作品全平台展映。',
    img: 'https://readdy.ai/api/search-image?query=A%20creative%20filmmaking%20scene%20with%20warm%20golden%20studio%20lighting%2C%20camera%20equipment%20silhouette%2C%20cinematic%20atmosphere%2C%20artistic%20composition%2C%20film%20production%20aesthetic&width=640&height=360&seq=card-07&orientation=landscape',
    tag: '官方活动',
    tagStyle: 'bg-primary-500/15 text-primary-400',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-50 font-heading">
            精选卡片
          </h2>
          <p className="mt-3 text-foreground-400 text-sm">
            编辑精选的热门影视内容与专题推荐
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {cards.slice(0, 6).map((card, i) => (
            <div
              key={i}
              className="group bg-background-100 border border-background-300/30 rounded-xl overflow-hidden hover:border-primary-500/30 transition-all duration-300 cursor-pointer flex flex-col"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={card.img}
                  alt={`蚂蚁影视 ${card.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  width="640"
                  height="360"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className={`inline-block px-2.5 py-1 text-[11px] font-medium rounded-md ${card.tagStyle}`}>
                    {card.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 flex flex-col flex-1">
                <h3 className="text-sm font-semibold text-foreground-100 group-hover:text-primary-400 transition-colors line-clamp-1">
                  {card.title}
                </h3>
                <p className="mt-2 text-xs text-foreground-500 leading-relaxed line-clamp-3 flex-1">
                  {card.desc}
                </p>
              </div>
            </div>
          ))}

          <div className="md:col-span-2 lg:col-span-3">
            <div className="bg-background-100 border border-background-300/30 rounded-xl overflow-hidden hover:border-primary-500/30 transition-all duration-300 cursor-pointer flex flex-col md:flex-row">
              <div className="relative w-full md:w-[360px] aspect-video md:aspect-auto flex-shrink-0 overflow-hidden">
                <img
                  src={cards[6].img}
                  alt={`蚂蚁影视 ${cards[6].title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  width="640"
                  height="360"
                  loading="lazy"
                />
              </div>
              <div className="p-5 flex flex-col justify-center">
                <span className={`inline-block px-2.5 py-1 text-[11px] font-medium rounded-md ${cards[6].tagStyle} mb-3 self-start`}>
                  {cards[6].tag}
                </span>
                <h3 className="text-base font-bold text-foreground-50 font-heading">
                  {cards[6].title}
                </h3>
                <p className="mt-2 text-sm text-foreground-500 leading-relaxed">
                  {cards[6].desc}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}